export default __webpack_public_path__ + "static/media/models.28e1da03.svg";